
import React from "react";



const provinces = [
  { fa: "تهران", en: "tehran", prefixes: ["021", "0910", "0912", "0919"], lat: 35.6892, lng: 51.3890 },
  { fa: "البرز", en: "alborz", prefixes: ["026"], lat: 35.9960, lng: 50.9289 },
  { fa: "اصفهان", en: "isfahan", prefixes: ["031", "0913"], lat: 32.6546, lng: 51.6680 },
  { fa: "فارس", en: "fars", prefixes: ["071", "0917"], lat: 29.1044, lng: 53.0450 },
  { fa: "مازندران", en: "mazandaran", prefixes: ["011", "0911"], lat: 36.2262, lng: 52.5319 },
  { fa: "گیلان", en: "gilan", prefixes: ["013"], lat: 37.2808, lng: 49.5832 },
  { fa: "خراسان رضوی", en: "razavi_khorasan", prefixes: ["051", "0915"], lat: 36.2970, lng: 59.6062 },
  { fa: "خراسان شمالی", en: "north_khorasan", prefixes: ["058", "0915"], lat: 37.4712, lng: 57.1013 },
  { fa: "خراسان جنوبی", en: "south_khorasan", prefixes: ["056", "0915"], lat: 32.8649, lng: 59.2163 },
  { fa: "کرمان", en: "kerman", prefixes: ["034", "0913"], lat: 30.2839, lng: 57.0834 },
  { fa: "آذربایجان شرقی", en: "east_azerbaijan", prefixes: ["041", "0914"], lat: 38.0700, lng: 46.3013 },
  { fa: "آذربایجان غربی", en: "west_azerbaijan", prefixes: ["044", "0914"], lat: 37.5297, lng: 45.0000 },
  { fa: "خوزستان", en: "khuzestan", prefixes: ["061", "0916"], lat: 31.3183, lng: 48.6706 },
  { fa: "کرمانشاه", en: "kermanshah", prefixes: ["083", "0918"], lat: 34.3142, lng: 47.0650 },
  { fa: "قم", en: "qom", prefixes: ["025", "0915"], lat: 34.6401, lng: 50.8764 },
  { fa: "قزوین", en: "qazvin", prefixes: ["028", "0912"], lat: 36.2688, lng: 50.0041 },
  { fa: "همدان", en: "hamedan", prefixes: ["081", "0918"], lat: 34.7980, lng: 48.5146 },
  { fa: "یزد", en: "yazd", prefixes: ["035", "0913"], lat: 31.8974, lng: 54.3569 },
  { fa: "سمنان", en: "semnan", prefixes: ["023", "0912"], lat: 35.5768, lng: 53.3921 },
  { fa: "گلستان", en: "golestan", prefixes: ["017", "0911"], lat: 36.8446, lng: 54.4358 },
  { fa: "زنجان", en: "zanjan", prefixes: ["024", "0912"], lat: 36.6765, lng: 48.4963 },
  { fa: "کردستان", en: "kurdistan", prefixes: ["087", "0918"], lat: 35.3149, lng: 46.9920 },
  { fa: "هرمزگان", en: "hormozgan", prefixes: ["076", "0917"], lat: 27.1832, lng: 56.2773 },
  { fa: "لرستان", en: "lorestan", prefixes: ["066", "0916"], lat: 33.4868, lng: 48.3558 },
  { fa: "چهارمحال و بختیاری", en: "chaharmahal_bakhtiari", prefixes: ["038", "0913"], lat: 31.9614, lng: 50.8450 },
  { fa: "ایلام", en: "ilam", prefixes: ["084", "0918"], lat: 33.6369, lng: 46.4227 },
  { fa: "سیستان و بلوچستان", en: "sistan_baluchestan", prefixes: ["054", "0915"], lat: 29.4963, lng: 60.8629 },
  { fa: "بوشهر", en: "bushehr", prefixes: ["077", "0917"], lat: 28.9185, lng: 50.8382 },
  { fa: "کهگیلویه و بویراحمد", en: "kohgiluyeh_boyerahmad", prefixes: ["074", "0917"], lat: 30.6682, lng: 51.5877 },
  { fa: "اردبیل", en: "ardabil", prefixes: ["045", "0914"], lat: 38.2500, lng: 48.3000 },

  // { fa: "کهکیلویه و بویراحمد", en: "kohgiluyeh_boyerahmad", prefixes: ["074", "0917"], lat: 30.6682, lng: 51.5877 },
];





const provinces_ = [
  { 
    fa: "آذربایجان شرقی", 
    en: "east_azerbaijan", 
    prefixes: ["041", "0914"],
    lat: 38.0805, lng: 46.2919 // تبریز
  },
  { 
    fa: "آذربایجان غربی", 
    en: "west_azerbaijan", 
    prefixes: ["044", "0914"],
    lat: 37.5522, lng: 45.0755  //ارومیه
  },
  { 
    fa: "اردبیل", 
    en: "ardabil", 
    prefixes: ["045", "0914"],
    lat: 38.2498, lng: 48.2963  //اردبیل
  },
  { 
    fa: "اصفهان", 
    en: "isfahan", 
    prefixes: ["031", "0913", "0935"],
    lat: 32.6546, lng: 51.6680  //اصفهان
  },
  { 
    fa: "البرز", 
    en: "alborz", 
    prefixes: ["026", "0912", "0939"],
    lat: 35.9960, lng: 50.9289  //کرج
  },
  { 
    fa: "ایلام", 
    en: "ilam", 
    prefixes: ["084", "0918"],
    lat: 33.6384, lng: 46.4226  //ایلام
  },
  { 
    fa: "بوشهر", 
    en: "bushehr", 
    prefixes: ["077", "0917", "0937"],
    lat: 28.9234, lng: 50.8203  //بوشهر
  },
  { 
    fa: "تهران", 
    en: "tehran", 
    prefixes: ["021", "0910", "0912", "0919", "0930", "0939"],
    lat: 35.6892, lng: 51.3890  //تهران
  },
  { 
    fa: "چهارمحال و بختیاری", 
    en: "chaharmahal_bakhtiari", 
    prefixes: ["038", "0918"],
    lat: 32.3266, lng: 50.8576  //شهرکرد
  },
  { 
    fa: "خراسان جنوبی", 
    en: "south_khorasan", 
    prefixes: ["056", "0915"],
    lat: 32.8649, lng: 59.2262  //بیرجند
  },
  { 
    fa: "خراسان رضوی", 
    en: "razavi_khorasan", 
    prefixes: ["051", "0915", "0935"],
    lat: 36.2989, lng: 59.6057  //مشهد
  },
  { 
    fa: "خراسان شمالی", 
    en: "north_khorasan", 
    prefixes: ["058", "0915"],
    lat: 37.4710, lng: 57.3229  //بجنورد
  },
  { 
    fa: "خوزستان", 
    en: "khuzestan", 
    prefixes: ["061", "0916", "0936"],
    lat: 31.3183, lng: 48.6706  //اهواز
  },
  { 
    fa: "زنجان", 
    en: "zanjan", 
    prefixes: ["024", "0914"],
    lat: 36.6736, lng: 48.4787  //زنجان
  },
  { 
    fa: "سمنان", 
    en: "semnan", 
    prefixes: ["023", "0912"],
    lat: 35.5728, lng: 53.3971  //سمنان
  },
  { 
    fa: "سیستان و بلوچستان", 
    en: "sistan_baluchestan", 
    prefixes: ["054", "0915"],
    lat: 29.4963, lng: 60.8629  //زاهدان
  },
  { 
    fa: "فارس", 
    en: "fars", 
    prefixes: ["071", "0917", "0937"],
    lat: 29.5926, lng: 52.5836  //شیراز
  },
  { 
    fa: "قزوین", 
    en: "qazvin", 
    prefixes: ["028", "0912"],
    lat: 36.2676, lng: 50.0041  //قزوین
  },
  { 
    fa: "قم", 
    en: "qom", 
    prefixes: ["025", "0912"],
    lat: 34.6399, lng: 50.8759  //قم
  },
  { 
    fa: "کردستان", 
    en: "kurdistan", 
    prefixes: ["087", "0918"],
    lat: 35.3020, lng: 46.9981  //سنندج
  },
  { 
    fa: "کرمان", 
    en: "kerman", 
    prefixes: ["034", "0913", "0933"],
    lat: 30.2839, lng: 57.0834  //کرمان
  },
  { 
    fa: "کرمانشاه", 
    en: "kermanshah", 
    prefixes: ["083", "0918"],
    lat: 34.3277, lng: 47.0778  //کرمانشاه
  },
  { 
    fa: "کهگیلویه و بویراحمد", 
    en: "kohgiluyeh_boyer_ahmad", 
    prefixes: ["074", "0917"],
    lat: 30.6500, lng: 51.6667  //یاسوج
  },
  { 
    fa: "گلستان", 
    en: "golestan", 
    prefixes: ["017", "0911"],
    lat: 36.8456, lng: 54.4342  //گرگان
  },
  { 
    fa: "گیلان", 
    en: "gilan", 
    prefixes: ["013", "0911"],
    lat: 37.2774, lng: 49.5890  //رشت
  },
  { 
    fa: "لرستان", 
    en: "lorestan", 
    prefixes: ["066", "0916"],
    lat: 33.4871, lng: 48.3538  //خرم‌آباد
  },
  { 
    fa: "مازندران", 
    en: "mazandaran", 
    prefixes: ["011", "0911", "0931"],
    lat: 36.5656, lng: 53.0588  //ساری
  },
  { 
    fa: "مرکزی", 
    en: "markazi", 
    prefixes: ["086", "0912"],
    lat: 34.0853, lng: 49.6833  //اراک
  },
  { 
    fa: "هرمزگان", 
    en: "hormozgan", 
    prefixes: ["076", "0917"],
    lat: 27.1836, lng: 56.2666  //بندرعباس
  },
  { 
    fa: "همدان", 
    en: "hamadan", 
    prefixes: ["081", "0918"],
    lat: 34.7989, lng: 48.5150  //همدان
  },
  { 
    fa: "یزد", 
    en: "yazd", 
    prefixes: ["035", "0913"],
    lat: 31.8974, lng: 54.3569  //یزد
  }
];


export function ProvinceSelect({ value, onChange }) {
  return (
    <select
      value={value.en}
      // onChange={(e) => onChange(e.target.value)}
      onChange={(e) => {
        const selected = provinces.find((p) => p.en === e.target.value);
        onChange(selected || null);
      }}
      className="p-2 rounded border form-control"
    >
      <option key='none' value="" disabled>انتخاب استان</option>
      {provinces.map((p) => (
        <option key={p.en} value={p.en}>
          {p.fa}
        </option>
      ))}
    </select>
  );
}


export function detectProvinceFromPhone(phone){
  const normalized = phone.replace(/\D/g, ""); // حذف غیر عدد
  for (const p of provinces) {
    for (const prefix of p.prefixes) {
      if (normalized.startsWith(prefix)) {
        return p;
      }
    }
  }
  return null;
}
